import { RouterProvider } from 'react-router-dom';
import { ConfigProvider } from 'antd';
import 'dayjs/locale/zh-cn';
import 'dayjs/locale/zh-tw';
import 'dayjs/locale/en';
import 'dayjs/locale/ja';
import 'dayjs/locale/ko';
import zhCN from 'antd/es/locale/zh_CN';
import zhTW from 'antd/es/locale/zh_TW';
import enUS from 'antd/es/locale/en_US';
import jaJP from 'antd/es/locale/ja_JP';
import koKR from 'antd/es/locale/ko_KR';
import i18n from '@/i18n';
import { isAppLocale, type AppLocale } from '@/constants/appLocale';

import useRootStore from '@/stores/rootStore';
import { RootProvider } from './contexts';
import router from './router';



const localeMap: Record<AppLocale, typeof zhCN> = {
  'zh_CN': zhCN,
  'zh_TW': zhTW,
  'en_US': enUS,
  'ja_JP': jaJP,
  'ko_KR': koKR,
}

export function App() {
  const rootStore = useRootStore();
  const { language } = i18n
  const antdLocale = isAppLocale(language) ? localeMap[language] : zhCN
  return (
    <RootProvider value={rootStore}>
      <ConfigProvider theme={{ token: { colorPrimary: '#3096FF' } }} locale={antdLocale}>
        <RouterProvider router={router} />
      </ConfigProvider>
    </RootProvider>
  );
}

